import React from 'react';
import { useNavigate } from 'react-router-dom';
import Leaderboard from '../components/Leaderboard';

export default function LeaderboardPage() {
  const navigate = useNavigate();
  return <Leaderboard onBack={() => navigate('/')} />;
}
